import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AssetModule } from '../modules/asset/asset.module';
import { AssetTypeModule } from '../modules/assetType/asset-type.module';
import { BulkAddModule } from '../modules/bulkAdd/bulk-add.module';
import { CustomerUserModule } from '../modules/customerUser/customer-user.module';
import { IssueModule } from '../modules/issue/issue.module';
import { MakeModule } from '../modules/make/make.module';
import { PartCategoryModule } from '../modules/partCategory/part-category.module';
import { PartsModule } from '../modules/parts/parts.module';
import { PartTypeModule } from '../modules/partType/part-type.module';
import { ProductModule } from '../modules/product/product.module';
import { QuestionModule } from '../modules/question/question.module';
import { SecurityRoutingStates } from '../modules/security/security-routing.module';
import { SecurityModule } from '../modules/security/security.module';
import { SPUserModule } from '../modules/spUser/sp-user.module';
import { SurveyManagementModule } from '../modules/surveyManagement/survey-management.module';
import { UserModule } from '../modules/user/user.module';

const appRoutes: Routes = [
  { path: '', pathMatch: 'full', redirectTo: 'console' },
  {
    path: 'console',
    loadChildren: () => SecurityModule
  },
  {
    path: 'console',
    loadChildren: () => ProductModule
  },
  {
    path: 'console',
    loadChildren: () => AssetModule
  },
  {
    path: 'console',
    loadChildren: () => AssetTypeModule
  },
  {
    path: 'console',
    loadChildren: () => MakeModule
  },
  {
    path: 'console',
    loadChildren: () => BulkAddModule
  },
  {
    path: 'console',
    loadChildren: () => UserModule
  },
  {
    path: 'console',
    loadChildren: () => IssueModule
  },
  {
    path: 'console',
    loadChildren: () => QuestionModule
  },
  {
    path: 'console',
    loadChildren: () => PartsModule
  },
  {
    path: 'console',
    loadChildren: () => PartTypeModule
  },
  {
    path: 'console',
    loadChildren: () => PartCategoryModule
  },
  {
    path: 'console',
    loadChildren: () => SPUserModule
  },
  {
    path: 'console',
    loadChildren: () => CustomerUserModule
  },
  {
    path: 'console',
    loadChildren: () => SurveyManagementModule
  },
  { path: '**', redirectTo: SecurityRoutingStates.PAGE_NOT_FOUND_STATE.url }
];

@NgModule({
  imports: [
    RouterModule.forRoot(
      appRoutes,
      { enableTracing: false } // <-- debugging purposes only
    )
  ],
  declarations: [],
  exports: [RouterModule]
})
export class AppRoutingModule {}
